import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ReactGA from 'react-ga';

import RegistrationPage from 'pages/Registration';
import ForgotPasswordPage from 'pages/ForgotPassword';
import ChangePasswordPage from 'pages/ChangePassword';
import TermsAndUse from 'pages/TermsAndUse';
import LoginPage from 'pages/Login';
import CookiesContainer from '../features/CookiesContainer';
import REACT_APP_GA_TRACKING_CODE from 'constants/googleAnalyticsCode'

import {
  REGISTRATION_PATH,
  LOGIN_PATH,
  FORGOT_PASSWORD_PATH,
  CHANGE_PASSWORD_PATH,
  LEGAL_TERM_PATH,
  COOKIE_SETTINGS_PATH
} from './constants';

ReactGA.initialize(REACT_APP_GA_TRACKING_CODE);

const AnonymousApp = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <Routes>
      <Route path={REGISTRATION_PATH} element={<RegistrationPage />} />
      <Route path={LOGIN_PATH} element={<LoginPage />} />
      <Route path={FORGOT_PASSWORD_PATH} element={<ForgotPasswordPage />} />
      <Route path={CHANGE_PASSWORD_PATH} element={<ChangePasswordPage />} />
      <Route path={COOKIE_SETTINGS_PATH} element={<CookiesContainer />} />
      <Route path={LEGAL_TERM_PATH} element={<TermsAndUse />} />
      <Route path="*" element={<Navigate to={LOGIN_PATH} replace />} />
    </Routes>
  );
};

export default AnonymousApp;